import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchHistoryList } from "@/api/PMS/customerService/lostAndFound/queryList";
import waves from "@/directive/waves"; // 水波纹指令

import receiveConfirm from "./receiveConfirm";
export default {
  components: {
    receiveConfirm: receiveConfirm
  },
  directives: {
    waves: waves
  },
  props: {
    showDialog: Boolean,
    keyValue: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        auditState: ""
      },
      id: null,
      title: "",
      noticeTypeId: -1,
      multipleSelection: [],
      dialogFormVisible: false,
      dialogReceiveConfirmVisible: false,
      isShow: true
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.listQuery = {
          page: 1,
          limit: 10,
          auditState: ""
        };
        this.getList();
      }
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      this.getList();

      if (reload) {
        //this.getList();
        this.$emit("handCancle", 3);
      }

      this.dialogReceiveConfirmVisible = false;
    },
    // 领取确认
    handleReceiveConfirm: function handleReceiveConfirm(id) {
      this.id = id;
      this.title = "领取确认";
      this.dialogReceiveConfirmVisible = true;
    },
    handShow: function handShow() {
      this.isShow = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.id = this.keyValue;
      fetchHistoryList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};